document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.brand-tab__button');
    const contentWrappers = document.querySelectorAll('.brand-tab__content-grid-wrapper');

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const id = button.getAttribute('data-id');

            buttons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            contentWrappers.forEach(wrapper => wrapper.classList.remove('active'));
            document.querySelector(`.brand-tab__content-grid-wrapper[data-id="${id}"]`).classList.add('active');
        });
    });
});